import { motion } from 'framer-motion';
import Section from '../components/Section';
import YouTubePlaylistFeed from '../components/YouTubePlaylistFeed';
import PageHero from '../components/PageHero';
import { SF_UI } from '../components/ui/tokens';

const NewsPage = () => {
  return (
    <>
      <PageHero
        eyebrow="About"
        title="News & Updates"
        subtitle="Stay updated with the latest developments, stories, and announcements from SportsFuture."
      />
      <Section bgColor={SF_UI.sectionBand} className="pt-12">
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5 }}
        className="max-w-6xl mx-auto"
      >
        {/* Featured Article */}
        <div className="mb-16">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.5 }}
            className="bg-white rounded-2xl shadow-lg sf-surface-card sf-ui-system overflow-hidden"
          >
            <div className="grid grid-cols-1 lg:grid-cols-2">
              <div className="h-64 lg:h-auto">
                <img
                  src="https://images.pexels.com/photos/7788009/pexels-photo-7788009.jpeg?auto=compress&cs=tinysrgb&h=650"
                  alt="SportsFuture Launch"
                  className="w-full h-full object-cover"
                />
              </div>
              <div className="p-8">
                <div className="text-sm text-primary font-medium mb-2">
                  June 15, 2025 • Featured Article
                </div>
                <h2 className="text-2xl font-bold mb-4">SportsFuture Launches on Apertum DEX</h2>
                <p className="text-gray-700 mb-6">
                  The SFUT token is now available for trading on the Apertum decentralized exchange, marking a major milestone for the platform.
                </p>
                <div className="prose prose-sm text-gray-600">
                  <p>
                    SportsFuture (SFUT) is now officially trading on the Apertum decentralized exchange, opening new opportunities for athletes and investors alike. This launch represents a significant step in our mission to create a decentralized ecosystem for sports funding and support.
                  </p>
                  
                  <p className="mt-4">The SFUT token will serve as the primary currency within the SportsFuture platform, enabling:</p>
                  <ul className="list-disc pl-4 mt-2 space-y-1">
                    <li>Direct funding of athlete scholarships and grants</li>
                    <li>Participation in governance decisions</li>
                    <li>Staking for platform rewards</li>
                    <li>Access to premium features and events</li>
                  </ul>
                  
                </div>
              </div>
            </div>
          </motion.div>
        </div>
        
        {/* YouTube Playlist Feed */}
        <YouTubePlaylistFeed />
        
        {/* Newsletter */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5 }}
          className="mt-16 bg-primary-50 rounded-2xl p-8 text-center sf-surface-card sf-ui-system border border-primary/10"
        >
          <h2 className="text-2xl font-bold mb-4">Subscribe to Our Newsletter</h2>
          <p className="text-gray-700 mb-6 max-w-xl mx-auto">
            Get the latest news and updates delivered directly to your inbox. Stay informed about new features, athlete stories, and opportunities.
          </p>
          <div className="max-w-md mx-auto">
            <div className="flex flex-col sm:flex-row gap-2">
              <input
                type="email"
                placeholder="Your email address"
                className="flex-grow px-4 py-2.5 rounded-xl border border-gray-300 focus:outline-none focus:ring-2 focus:ring-primary"
              />
              <button className="bg-primary hover:bg-primary-600 text-white font-medium rounded-xl px-6 py-2.5 transition-colors sf-cta">
                Subscribe
              </button>
            </div>
            <p className="text-xs text-gray-500 mt-3">
              We respect your privacy. Unsubscribe at any time.
            </p>
          </div>
        </motion.div>
      </motion.div>
      </Section>
    </>
  );
};

export default NewsPage;